export const colors = {
    primary800: '#317e72',
    primary600: '#69b6aa',
    primary300: '#c2e9e3',
    primary100: '#e9f4f3',

    secondary: '#facf1a',
    secondaryDarker: '#f2c400',

    success: '#28a745',
    warning: '#ffc107',
    error: '#dc3545',
    info: '#17a2b8',

    black: '#000000',
    white: '#FFFFFF',

    gray1: '#CECECE',
    gray2: '#7F7F7F',

    grey1: '#F9FAFA',
    grey2: '#F1F2F2',
    grey3: '#E5E5E5',
    grey4: '#DADBDC',
    grey5: '#7F8286',
    grey6: '#555555',
    grey7: '#959394',
    dark: '#1D1737',

    blue1: '#7ABFCC',
    blue2: '#6CC0E5',
    blue3: '#45A4FF',
    blue4: '#5297D4',
    blue5: '#7BC1E9',
    blue6: '#70C9FF',
    blue7: '#7F9FD6',
    blue8: '#68CDF2',
    yellow1: '#FFDF59',
    yellow2: '#FFC570',
    red1: '#E79C93',
    red2: '#F06B7F',
    red3: '#F67A84',
    red4: '#F8AEB8',
    red5: '#ea6262',
    orange: '#F99B64'
}
